export const selectErrorNotifications = state => state.getIn(['notifications', 'errors']);
export const selectSuccessNotifications = state => state.getIn(['notifications', 'successes']);
export const selectCheckinNotifications = state => state.getIn(['notifications', 'checkins']);
